<template>
    <flex-element :element-type="elementType">
        <div v-if="!isTemplateScreen" class="always-enabled">
            <drop-zone-multi
                v-bind="element(1)"
                :in-placeholder="true"
                :top-level="true"
                @element-updated="elementUpdated"
            />
        </div>

        <div v-else class="flex-template-drop-zone" />

        <slot />
    </flex-element>
</template>

<script>
import { Rendering } from '@/data/data-models';
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    name: 'flex-placeholder',
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Placeholder',
        },

        tag: {
            type: String,
            default: '',
        },

        idOverride: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            isCollapsed: false,
            tagNew: '',
            idOverrideNew: '',
        };
    },

    computed: {
        updatedElement() {
            const rendering = new Rendering({
                ...this.updatedBaseElement,
                renderingId: this.renderingId,
                renderingName: this.renderingName,
                dataSourceId: this.dataSourceId,
                elements: this.elementsNew,
                tag: this.tagNew,
                idOverride: this.idOverrideNew,
            });

            return rendering;
        },
    },

    created() {
        this.atomicType = 'template';
        this.templateType = 'flex-placeholder';
    },

    beforeMount() {
        this.setFieldValues();
    },

    methods: {
        setFieldValues() {
            this.idOverrideNew = this.idOverride;
            this.tagNew = this.tag;
        },

        onClick(e) {
            if (this.isTemplateScreen) {
                this.onSetElementSelection(e);

                // flex-element swallows the clicks, thus preventing context menu from closing:
                this.$root.$emit('flex::context::close');

                // cancel movement mode if a new element is selected
                if (this.moving) {
                    this.clearCopiedRendering();
                }
            } else {
                this.setSelectedRendering({ rendering: this });

                if (e.target === this.$el) this.setSelectedElement({ element: this });
            }
        },

        removeRenderingAtIndex() {
            this.$emit('delete-rendering', this.index);
        },
    },
};
</script>

<style lang="scss">
.flex-template-drop-zone {
    @include stripes($placeholder-stripe-color, rgba($placeholder-stripe-color, 0.85));
    height: 100px;
    width: 100%;

    &:after {
        content: "DROP ZONE";
        @extend %center-middle;
        font-size: 30px;
        color: $placeholder-text-color;
    }
}

.always-enabled {
    pointer-events: all;
}
</style>
